import { useToken } from "lib/contexts/TokenProvider";
import EmptyCart from "./empty-cart";
import Cart from "./cart";

const CartWrapper = () => {
  const {
    state: { productType },
  } = useToken();

  const getCart = () => {
    switch (productType) {
      case "EMPTY_CART":
        return <EmptyCart />;
      case "BACKGROUND_CART":
      case "CART":
        return <Cart />;
      default:
        return <></>;
    }
  };

  return getCart();
};

export default CartWrapper;
